<template >
  <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
      <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px"> لیست مشتریان</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important">
                <v-card>
                    <v-card-title>
                     <v-layout row wrap>
                         <v-flex xs12 sm12 md9 lg9 xl9 style="padding-right:15px;padding-left:15px;">
                             <v-text-field outlined dense color="#262d47" placeholder="جستجو" v-model="searchusers" append-icon="fas fa-search"></v-text-field>   
                         </v-flex>
                         <v-flex xs12 sm12 md3 lg3 xl3 style="padding-right:15px;padding-left:15px;">
                            <v-btn outlined color="#4CAF50" @click="AddCustomer = true" dark><v-icon small style="padding-left:5px;">fa fa-plus</v-icon>&nbsp;مشتری جدید</v-btn>&nbsp;
                            <JsonExcel style="display: inline-block;padding-left: 5px;" :data="userTableItems" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExportDataColumns">
                                  <v-btn outlined color="#2a2d45" dark><v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل</v-btn>&nbsp;
                              </JsonExcel>
                         </v-flex>
                     </v-layout>
                    </v-card-title>
                    <v-card-text>
                    <v-data-table items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingUser" :headers="userTableHeader" :search="searchusers" :items="userTableItems">
                        
                        
                        <template v-slot:[`item.u_Status`]="{ item }">
                            <v-btn small text color="#D32F2F" @click="ActiveItem(item.u_Id)" dark v-if="item.u_Status == 2">غیر فعال</v-btn>
                            <v-btn small text color="#2E7D32" @click="DisableItem(item.u_Id)" dark v-else> فعال</v-btn>
                        </template>
                    </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
      </v-layout>
      
      
      <template>
        <v-dialog persistent max-width="500" v-model="AddCustomer">
            <v-card>
                <v-card-title style="padding:0px">
                    <v-toolbar dense flat color="#262d47">
                        <v-toolbar-title>
                            <span style="color:orange">مشتری جدید</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="red" @click="AddCustomer = false">fa fa-times</v-icon>
                    </v-toolbar>
                </v-card-title>
                <v-card-text class="pt-3">
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12 lg12 xl12>
                            <v-autocomplete v-model="UserModel.U_CatId" :items="UserCats" item-color="red" item-text="uC_Title" item-value="uC_Id" outlined dense label="دسته بندی"></v-autocomplete>
                            <v-text-field v-model="UserModel.U_Name" style="direction:rtl" outlined dense label="نام"></v-text-field>
                            <v-text-field v-model="UserModel.U_Family" style="direction:rtl" outlined dense label="نام خانوادگی"></v-text-field>
                            <v-text-field v-model="UserModel.U_Phone" outlined dense label="تلفن همراه "></v-text-field>
                            <v-btn @click="NewCustomer" outlined dark block color="green accent-4"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </template>
  </div>
</template>
<script>
import JsonExcel from "vue-json-excel";
var UM = {
U_CatId:0,
U_Name:"",
U_Family:"",
U_Phone:"",
U_Role : 2
};
const ApiUrl = require("../../constant/apiurl");
const MSGHNDL = require("../../constant/MessageHandler");
const axios = require('axios');
export default {
    components:{
        JsonExcel
    },
    name:"customer",
    data:()=>({
        UserModel:Object.assign({},UM),
        searchusers:"",
        isLoadingUser:false,
        userStepperFormModel:1,
        uName:"",
        uFamily:"",
        userAvatar:"",
        phoneMask:"",
        uPhone:"",
        uEmail:"",
        uPassword:"",
        UConfirmPassword:"",
        SelectedPermissions:[],
        uNameRule:[],
        uFamilyRule:[],
        uPhoneRule:[],
        uEmailRule:[],
        Permissions:[],
        uPasswordRule:[],
        UConfirmPasswordRule:[],
        userTableHeader:
        [
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"نام و نام خانوادگی",value:"surename",sortable:true,align:"right"},
            {text:"تلفن",value:"u_Phone",sortable:true,align:"right"},
            {text:"پست الکترونیکی",value:"u_Email",sortable:true,align:"right"},
           
            {text:"وضعیت",value:"u_Status",sortable:true,align:"right"},
            /*{text:"عملیات",value:"operation",sortable:true,align:"right"},*/
        ],
        ExportDataColumns:{
            'نام و نام خانوادگی':'surename',
            'تلفن همراه':'u_Phone',
            'پست الکترونیکی':'u_Email'
        },
        WalletHistoryTableHeaders:[
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"مبلغ",value:"amount",sortable:true,align:"right"},
            {text:"نوع تراکنش",value:"type",sortable:true,align:"right"},
            {text:"کاربر",value:"user",sortable:true,align:"right"},
            {text:"تاریخ",value:"date",sortable:true,align:"right"},
        ],
        userTableItems:
        [
        ],
        userCreationDialog:false,
        inEditingMode : false,
        EditItem:{},
        chargeWalletDialog:false,
        userId:0,
        wallet:0,
        walletModel:0,
        rwalletModel:0,
        chargingWallet:false,
        reducingWallet:false,
        walletHistoryDialog:false,
        WalletHistoryItems:[],
        transactionDescription:"",
        AddCustomer:false,
        UserCats:[]
    }),
    async created(){
        let vm = this;
        await vm.loadUserCats();
        await vm.loadUsers();
    },
    methods:{
        async NewCustomer()
        {
            let vm = this;
            vm.isLoadingCats = true;
            await axios.post(ApiUrl.SysUserAdd,vm.UserModel).then((res)=>{
                vm.isLoadingCats = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.loadUsers();
                   MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{
                vm.isLoadingCats = false;
                console.error(err);
            });
        },
        async loadUserCats()
        {
            let vm = this;
            vm.isLoadingCats = true;
            await axios.post(ApiUrl.CustomerCat.Combo).then((res)=>{
                vm.isLoadingCats = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.UserCats = data.data;
                }
            }).catch((err)=>{
                vm.isLoadingCats = false;
                console.error(err);
            });
        },
        async loadWalletHistory(id)
        {
            let vm = this;
            var url=ApiUrl.CustomerWalletHistory;
            var data = {};
            vm.walletHistoryDialog = true;
            data.U_Id = id;
            await axios.post(url,data)
                .then(function (res) {
                    console.log(res);
                    if(res.data.status)
                    {
                       vm.WalletHistoryItems = res.data.data;
                       console.warn(res.data.data);
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        },

        async ChargeWallet()
        {
            var vm = this;
            if(vm.walletModel <= 0)
            {
                MSGHNDL.ERR("مبلغ نمیتواند صفر باشد");
                return;
            }
            if(vm.transactionDescription == "" || vm.transactionDescription == null)
            {
                MSGHNDL.ERR("توضیحات تراکنش الزامی میباشد");
                return;
            }
            var Model = {};
            Model.U_Id = vm.userId;
            Model.U_Wallet = vm.walletModel;
            Model.Token = vm.transactionDescription;
            Model.U_Coupon = 0;
            vm.chargingWallet = true;
            await axios.post(ApiUrl.CustomerChargeWallet,Model).then(async (res)=>{
                var data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadUsers();
                    vm.walletModel = 0;
                    vm.transactionDescription = "";
                    vm.chargeWalletDialog = false;
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
                vm.chargingWallet = false;
            }).catch((err)=>{
                console.error(err);
                vm.chargingWallet = false;
            });
        },
        async RecuceWallet()
        {
            var vm = this;
            if(vm.walletModel <= 0)
            {
                MSGHNDL.ERR("مبلغ نمیتواند صفر باشد");
                return;
            }
            if(vm.transactionDescription == "" || vm.transactionDescription == null)
            {
                MSGHNDL.ERR("توضیحات تراکنش الزامی میباشد");
                return;
            }
            var Model = {};
            Model.U_Id = vm.userId;
            Model.U_Wallet = vm.walletModel;
            Model.Token = vm.transactionDescription;
            Model.U_Coupon = 0;
            vm.reducingWallet = true;
            await axios.post(ApiUrl.CustomerDeacreaseWallet,Model).then(async (res)=>{
                var data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadUsers();
                    vm.walletModel = 0;
                    vm.transactionDescription = "";
                    vm.chargeWalletDialog = false;
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
                vm.reducingWallet = false;
            }).catch((err)=>{
                console.error(err);
                vm.reducingWallet = false;
            });
        },
        chargeWallet(item)
        {
            let vm = this;
            vm.userId = item.u_Id;
            vm.wallet = item.wallet;
            vm.chargeWalletDialog = true;
        },
        
        closeDialog()
        {
            let vm = this;
            vm.$refs.uPersonalInfoFrom.reset();
            vm.SelectedPermissions = [];
            vm.inEditingMode = false;
            vm.userCreationDialog = false;
        },
        async DisableItem(id)
        {
            let vm = this;
            let Model = {};
            Model.U_Id = id;
            await axios.post(ApiUrl.SysUserSuspend,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadUsers();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async ActiveItem(id)
        {
            let vm = this;
            let Model = {};
            Model.U_Id = id;
            await axios.post(ApiUrl.SysUserActive,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadUsers();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        editUser(user)
        {
            let vm = this;
            vm.SelectedPermissions = user.permissions;
            vm.uName = user.u_Name;
            vm.uFamily = user.u_Family;
            vm.uEmail = user.u_Email;
            vm.uPhone = user.u_Phone;
            vm.inEditingMode = true;
            vm.EditItem = user;
            vm.userCreationDialog = true;
        },
        JumpStep(step)
        {
            let vm = this;
            vm.userStepperFormModel = step;
        },
        async registerUser()
        {
            let vm = this;
            let url = ApiUrl.SysUserAdd;
            var Model = {};
            console.warn(vm.SelectedPermissions);
            if(vm.inEditingMode)
            {
                url = ApiUrl.SysUserUpdate;
                Model.U_Id = vm.EditItem.u_Id;
            }
            else
            {
                Model.U_Password = vm.uPassword;
            }
            
            Model.U_Name = vm.uName;
            Model.U_Family = vm.uFamily;
            Model.U_Email = vm.uEmail;
            Model.U_Phone = vm.uPhone;
            Model.U_Role = 1;
            Model.Permissions = vm.SelectedPermissions;
            await axios.post(url,Model)
            .then(async function(res){
                var data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    vm.closeDialog();
                    await vm.loadUsers();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch(function(err){
                console.error(err);
            });
        },
        async loadUsers()
        {
            let vm = this;
            var url=ApiUrl.SysUserLoad+'/2';
            
            await axios.post(url)
                .then(function (res) {
                    console.log(res);
                    if(res.data.status)
                    {
                       vm.userTableItems = res.data.data;
                       console.warn(res.data.data);
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        }
    }
}
</script>
<style scoped>
.padding-20
{
    padding:20px;
}
</style>
<style>
.v-stepper__step--inactive .v-stepper__label
{
    color: rgba(255, 255, 255, 0.13) !important;
}
.theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
    background: rgb(57, 64, 88) !important;
}
</style>